import PortfolioGridPage from './PortfolioGridPage';

export default function LabPage() {
  return (
    <PortfolioGridPage
      contentType="lab"
      aspectRatio="aspect-square"
      showHoverOverlay
      showDescription={false}
      emptyLabel="실험"
    />
  );
}
